import {loadableReady} from '@loadable/component'
import {createBrowserHistory} from 'history'
import React from 'react'
import {hydrate} from 'react-dom'
import {I18nextProvider} from 'react-i18next'
import {Provider} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import {Router} from 'react-router-dom'

import App from '~/App'
import i18n, {i18nInitPromise} from '~/lib/i18n'
import getRoutes from '~/routes'
import {createStore} from '~/stores'

import PendingNavDataLoader from './PendingNavDataLoader'

import './index.css'

// 纯官网暂时不启用sentry
// sentry()

const history = createBrowserHistory()
export {history}

// 在创建store时添加类型检查
const initialState =
  typeof window.APP_INITIAL_STATE === 'object' && window.APP_INITIAL_STATE
    ? window.APP_INITIAL_STATE
    : undefined
const store = createStore(initialState)
window.store = store
window.APP_INITIAL_STATE = null
const routes = getRoutes(store)

const application = (
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <Router history={history}>
        <PendingNavDataLoader store={store} routes={routes}>
          {() => <App>{renderRoutes(routes)}</App>}
        </PendingNavDataLoader>
      </Router>
    </Provider>
  </I18nextProvider>
)

// 将 loadableReady 包装成 Promise
const loadableReadyPromise = new Promise<void>((resolve) => {
  loadableReady(() => {
    resolve()
  })
})

// 等待 loadable 和 i18n 都准备好后再渲染应用
Promise.all([loadableReadyPromise, i18nInitPromise]).then(() => {
  const root = document.getElementById('app')

  hydrate(application, root)

  // 等待浏览器完成一次重绘，确保 CSS 模块样式已应用
  // 一个 requestAnimationFrame 就够了，两个是过度优化
  requestAnimationFrame(() => {
    // 标记样式加载完成，显示隐藏的元素
    if (document.body) {
      document.body.classList.add('_styles-loaded')
    }
  })
})
